var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"link\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5959 14.708C11.1147 15.4016 11.7766 15.9755 12.5367 16.3907C13.2968 16.806 14.1373 17.0529 15.0012 17.1148C15.8651 17.1767 16.7322 17.052 17.5437 16.7493C18.3552 16.4466 19.0921 15.9729 19.7045 15.3604L23.3285 11.7363C24.4288 10.5971 25.0376 9.07135 25.0239 7.48765C25.0101 5.90394 24.3749 4.389 23.255 3.26911C22.1351 2.14922 20.6201 1.51399 19.0364 1.50023C17.4527 1.48647 15.927 2.09528 14.7878 3.19554L12.71 5.26126",
    stroke: "#575F6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4281 12.292C14.9093 11.5984 14.2475 11.0245 13.4874 10.6093C12.7273 10.194 11.8868 9.94705 11.0229 9.88517C10.159 9.8233 9.29186 9.94795 8.48036 10.2507C7.66885 10.5534 6.93195 11.0271 6.31962 11.6396L2.69554 15.2637C1.59528 16.4029 0.986466 17.9286 1.00023 19.5123C1.01399 21.096 1.64922 22.611 2.76911 23.7309C3.889 24.8508 5.40394 25.486 6.98765 25.4998C8.57135 25.5135 10.0971 24.9047 11.2363 23.8045L13.302 21.7387",
    stroke: "#575F6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d57052d81ea07bbc53140571cec318c5.svg";
export { ForwardRef as ReactComponent };